import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label", "disabled"]
const _hoisted_2 = { class: "grid grid-cols-2 relative overflow-hidden" }

import { computed } from 'vue';

type AcceptedModelValue = boolean | number | string;

interface Props {
    modelValue: AcceptedModelValue;
    trueText: string;
    falseText: string;
    trueValue: AcceptedModelValue;
    falseValue: AcceptedModelValue;
    disabled?: boolean;
    size?: 'default' | 'sm';
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SwitchButton',
  props: {
    modelValue: { type: [Boolean, Number, String] },
    trueText: {},
    falseText: {},
    trueValue: { type: [Boolean, Number, String] },
    falseValue: { type: [Boolean, Number, String] },
    disabled: { type: Boolean, default: undefined },
    size: { default: 'default' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const computedModelValue = computed({
    get() {
        return props.modelValue === props.trueValue;
    },
    set(newValue: boolean) {
        const value = newValue ? props.trueValue : props.falseValue;

        emit('update:modelValue', value);
    },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["bg-gray-200 rounded-md cursor-pointer disabled:cursor-not-allowed", {
            'opacity-50': _ctx.disabled,
            'p-0.5': _ctx.size === 'sm',
            'p-1': _ctx.size === 'default',
        }]),
    "aria-label": computedModelValue.value ? _ctx.falseText : _ctx.trueText,
    disabled: _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (computedModelValue.value = !computedModelValue.value))
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["absolute top-0 left-0 w-1/2 h-full rounded-md bg-primary-800 transition-transform duration-300", computedModelValue.value ? '' : 'transform translate-x-full']),
        "aria-hidden": "true"
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["relative h-full border-0 transition-colors duration-300 focus:outline-none font-medium", {
                    'text-white': computedModelValue.value,
                    'px-2 py-1 text-sm': _ctx.size === 'sm',
                    'px-4 py-2': _ctx.size === 'default',
                }])
      }, _toDisplayString(_ctx.trueText), 3),
      _createElementVNode("div", {
        class: _normalizeClass(["relative h-full border-0 transition-colors duration-300 focus:outline-none font-medium", {
                    'text-white': !computedModelValue.value,
                    'px-2 py-1 text-sm': _ctx.size === 'sm',
                    'px-4 py-2': _ctx.size === 'default',
                }])
      }, _toDisplayString(_ctx.falseText), 3)
    ])
  ], 10, _hoisted_1))
}
}

})